// removed by extract-text-webpack-plugin
module.exports = {"base":"Level_base--1Kwer","icon":"Level_icon--26LzJ","icon-shadow":"Level_icon-shadow--nPucD","iconShadow":"Level_icon-shadow--nPucD"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Level/Level.scss
// module id = 497
// module chunks = 11 12